import backend from "../server/backend";
import { toast } from "react-toastify";
import { localStorageAuth, localStorageCurrentRoute, localStorageToken, localStorageRememberUser } from "../config";

const signinUser = (dispatch) => {
  return async (data, callback) => {
    try {
      let token = localStorage.getItem(localStorageToken);
      if (!token) {
        token = Date.now() + Math.random().toString(36);
        localStorage.setItem(localStorageToken, token);
      }

      data.token = token;
      data.ipAddress = "1.0.0.27";

      if (process.env.NODE_ENV === "production") {
        let { data: remoteClient } = await backend.get("https://ipapi.co/json/");
        data.ipAddress = remoteClient.ip;
      }

      const response = await backend.post("/login", { data });

      if (data.rememberUsername) {
        const deviceObj = { username: data.username, firstname: response.data.user.firstname };
        const jsonContent = JSON.stringify(deviceObj);
        localStorage.setItem(localStorageRememberUser, jsonContent);
      }

      dispatch({
        type: "setAuthUser",
        payload: { user: response.data.user, jwt: response.data.jwt },
      });

      const jsonValue = JSON.stringify(response.data.jwt);
      localStorage.setItem(localStorageAuth, jsonValue);

      callback("/dashboard");
    } catch (err) {
      console.log("AppWorkflow - signinUser from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const dispatchAction = (dispatch) => {
  //This Dispatch action is only responsible of updating the app State.
  return (action, data) => {
    dispatch({ type: action, payload: data });
  };
};

const generateAccessCodes = (dispatch) => {
  return async (creditor_id, type, codes) => {
    try {
      await backend.post("/route/access/codes", { creditor_id, type, codes });
      dispatch({
        type: "setSnackbar",
        payload: { open: true, type: "success", duration: 3000, message: "Codigos de aceso guardado!" },
      });
    } catch (err) {
      console.log("AppWorkflow - generateAccessCodes from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const createEmployee = (dispatch) => {
  return async (data, callback) => {
    try {
      const response = await backend.post("/employee/create", { data });
      console.log("AppWorkflow - createEmployee from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "createEmployee", payload: response.data });

      callback();
      dispatch({
        type: "setSnackbar",
        payload: { open: true, type: "success", duration: 3000, message: "Empleado fue creado!" },
      });
    } catch (err) {
      console.log("AppWorkflow - createEmployee from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const createRoute = (dispatch) => {
  return async (data) => {
    try {
      const response = await backend.post("/route/create", { data });
      console.log("AppWorkflow - createRoute from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "createRoute", payload: response.data });

      return response.data.creditor_id;
    } catch (err) {
      console.log("AppWorkflow - createRoute from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const modifyRoute = (dispatch) => {
  return async (data) => {
    try {
      const response = await backend.put("/route/modify", { data });
      console.log("AppWorkflow - modifyRoute from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "modifyRoute", payload: response.data });

      dispatch({
        type: "setSnackbar",
        payload: { open: true, duration: 3000, type: "info", message: "Ruta fue actualizada!" },
      });
    } catch (err) {
      console.log("AppWorkflow - modifyRoute from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const modifyRouteConfig = (dispatch) => {
  return async (data) => {
    try {
      const response = await backend.post("/route/modify/config", { data });
      console.log("AppWorkflow - modifyRoute from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "modifyRoute", payload: response.data });

      dispatch({
        type: "setSnackbar",
        payload: { open: true, duration: 3000, type: "info", message: "Ruta configuracion guardada!" },
      });
    } catch (err) {
      console.log("AppWorkflow - modifyRoute from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const setDebtorsReorderedMain = () => {
  return async (debtors) => {
    try {
      await backend.post("/debtors/organize", { debtors });
    } catch (err) {
      console.log("AppWorkflow - organizeDebtorsOrder from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const modifyLoan = (dispatch) => {
  return async (loan, callBack) => {
    try {
      await backend.put("/loan/modify", { data: loan });

      dispatch({
        type: "setSnackbar",
        payload: { open: true, duration: 5000, type: "info", message: `Prestamo modificado con exito!` },
      });

      callBack();
    } catch (err) {
      console.log("AppWorkflow - loanModify from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const setReferral = (dispatch) => {
  return async (data) => {
    dispatch({ type: "setReferral", payload: data });
  };
};

const toggleLinkedRoute = (dispatch) => {
  return async (user, { creditor_id, route_location }) => {
    try {
      const response = await backend.post("/toggleLinkRoute", { user, creditor_id, route_location });
      console.log("AppWorkflow - toggleLinkedRoute from dataContext - Promise Resolved data:", response.data);

      // dispatch({ type: "toggleLinkedRoute", payload: user });
    } catch (err) {
      console.log("AppWorkflow - toggleLinkedRoute from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const getDebtorRenewal = (dispatch) => {
  return async (data) => {
    try {
      const response = await backend.post("/debtor/renewal", { data });
      console.log("AppWorkflow - getDebtorRenewal from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "getDebtorRenewal", payload: response.data });
    } catch (err) {
      console.log("AppWorkflow - getDebtorRenewal from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const fetchDebtorImages = (dispatch) => {
  return async (debtor_id, creditor_id) => {
    try {
      const response = await backend.post("/debtor/images", { debtor_id, creditor_id });
      console.log("AppWorkflow - fetchDebtorImages from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "fetchDebtorImages", payload: response.data });
      return response.data;
    } catch (err) {
      console.log("AppWorkflow - fetchDebtorImages from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const createLoan = (dispatch) => {
  return async (data, callback) => {
    data.amount = data.amount * 1;
    data.actanotarial = data.actanotarial * 1;
    data.adelanto = data.adelanto * 1;
    const newData = {
      ...data,
      payoffOldLoans: "replaced",
      signature: "replaced",
      signature2: "replaced",
      template: "replaced",
    };

    try {
      if (data.payoffBalance > 0) {
        // const totalPayoff = data.payoffOldLoans.length;
        // const loans = data.payoffOldLoans;

        // for (let i = 0; i < totalPayoff; i++) {
        //   if (loans[i].isChecked === false) continue;
        const { money_id, modified_time, balance } = data.currentLoan;
        const payoffData = {
          paymentAmount: balance,
          paidFromRenewal: true,
          paymentMora: 0,
          creditor_id: data.creditor_id,
          name: data.name,
          money_id,
          modified_time,
          payoffLoanId: data.money_id,
          user_id: data.user_id,
          debtor_id: data.debtor_id,
          payment_date: data.given_date,
          // new_debtor: data.new_debtor,
        };

        await backend.post("/payment/create", { data: payoffData });
        // }
      }

      const { data: newLoan } = await backend.post("/loan/create", { data: { ...newData } });

      if (data.adelanto > 0) {
        const payoffData = {
          paymentAmount: data.adelanto,
          paymentMora: 0,
          name: data.name,
          money_id: newLoan.money_id,
          creditor_id: data.creditor_id,
          modified_time: "byPass",
          user_id: data.user_id,
          debtor_id: data.debtor_id,
          payment_date: data.given_date,
          new_debtor: data.new_debtor,
        };

        await backend.post("/payment/create", { data: payoffData });
      }

      if (data.signature) {
        const sigData = { ...data, money_id: newLoan.money_id, payoffOldLoans: undefined };

        await backend.post("/save/loan/signature", { data: sigData });
      }

      dispatch({
        type: "setSnackbar",
        payload: { open: true, duration: 5000, type: "success", message: `Prestamo guardado con exito!` },
      });

      callback();
    } catch (err) {
      console.log("AppWorkflow - createNewLoan from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const createLoanWithAtrasos = (dispatch) => {
  return async (data, callback) => {
    data.amount = data.amount * 1;
    data.actanotarial = data.actanotarial * 1;
    data.adelanto = data.adelanto * 1;
    const newData = {
      ...data,
      payoffOldLoans: "replaced",
      signature: "replaced",
      signature2: "replaced",
      template: "replaced",
    };

    try {
      const { data: newLoan } = await backend.post("/loan/old/create", { data: { ...newData } });

      if (data.signature) {
        const sigData = { ...data, money_id: newLoan.money_id, payoffOldLoans: undefined };

        await backend.post("/save/loan/signature", { data: sigData });
      }

      dispatch({
        type: "setSnackbar",
        payload: { open: true, duration: 5000, type: "success", message: `Prestamo guardado con exito!` },
      });

      callback();
    } catch (err) {
      console.log("AppWorkflow - createNewLoan from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const setUserRole = (dispatch) => {
  return async (user, role, creditor_id) => {
    let { role_id } = role;
    let { user_id } = user;
    try {
      const response = await backend.post("/setUserRole", { user_id, role_id, creditor_id });
      // dispatch({ type: "setUserRole", payload: { user, role } });
      console.log("AppWorkflow - setUserRole from dataContext - Promise Resolved data:", response.data);
    } catch (err) {
      toast.error("Hubo un problema guardando su ultima transacion!");
      console.log("AppWorkflow - setUserRole from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const fetchLoanPayments = (dispatch) => {
  return async (money_id, user_id) => {
    try {
      const response = await backend.post("/loan/payments", { money_id, user_id });
      console.log("AppWorkflow - getLoanPayments from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "fetchLoanPayments", payload: response.data, money_id });
    } catch (err) {
      console.log("AppWorkflow - getLoanPayments from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const changeRoute = (dispatch) => {
  return async (creditor_id, user, history) => {
    // const { user_id: owner_id, creditor_id } = routeData;

    try {
      const { data: route } = await backend.get(`/route/info/${creditor_id}/${user.user_id}`);
      // const response = await backend.get(`/loans/${creditor_id}/${user_id}/${response3.data.next_week_date}`);
      // const response2 = await backend.get(`/debtors/${creditor_id}/${user_id}`);
      // const response4 = await backend.post(`/route/config/${creditor_id}`);
      // const response5 = await backend.post("/user/route/permission", { user_id, creditor_id, owner_id });

      // dispatch({ type: "fetchRouteInfo", payload: route });

      const routeInfo = {
        creditor_id: route.creditor_id,
        user_id: route.user_id,
        owner_id: route.user_id,
        route_name: route.route_name,
        location: route.location,
        ISO: route.ISO,
        today_date: route.today_date,
        // current_week_date: route.current_week_date,
        // current_range_date: route.current_range_date,
        // next_week_date: route.next_week_date
      };

      const jsonValue = JSON.stringify({
        ...routeInfo,
      });

      localStorage.setItem(localStorageCurrentRoute, jsonValue);
      dispatch({ type: "fetchRouteInfo", payload: { route: routeInfo, user: user } });

      // dispatch({ type: "fetchRouteInfo", payload: response3.data, creditor_id });
      // dispatch({ type: "updateRouteConfig", payload: response4.data, creditor_id });
      // dispatch({ type: "setPermissions", payload: response5.data, creditor_id });
      // dispatch({ type: "fetchLoans", payload: response.data, creditor_id });
      // dispatch({ type: "fetchDebtors", payload: response2.data, creditor_id });

      //From these pages, route change will not redirect to /dashboard Page.
      const excludedPath = ["/debtors", "/collected", "/entregas", "/employees", "/loans", "/settings", "/spenses"];
      if (!excludedPath.includes(history.location.pathname)) {
        history.replace("/dashboard");
      }
    } catch (e) {
      console.log("AppWorkflow - getRouteInfo from dataContext");
    }
  };
};

const updateUserConfig = () => {
  return async (user_id, data, callback) => {
    try {
      await backend.put("/user/config", { user_id, ...data });
      await callback();
      // dispatch({ type: "updateUserConfig", payload: response.data });
    } catch (err) {
      console.log("AppWorkflow - updateDebtor from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const updateRouteConfig = () => {
  return async (creditor_id, data, callback) => {
    try {
      await backend.put("/route/config", { creditor_id, ...data });
      await callback();
      // dispatch({ type: "updateRouteConfig", payload: response.data });
    } catch (err) {
      console.log("AppWorkflow - updateDebtor from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const fetchNewLoans = (dispatch) => {
  return async (creditor_id, dates) => {
    try {
      const response = await backend.post("/loans/new", { creditor_id, ...dates });
      console.log("AppWorkflow - fetchNewLoans from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "fetchNewLoans", payload: response.data, creditor_id, dates });
    } catch (e) {
      console.log("AppWorkflow - fetchNewLoans from dataContext - Restored State");
    }
  };
};

const fetchDebtors = (dispatch) => {
  return async (creditor_id, user_id) => {
    try {
      const response = await backend.get(`/debtors/${creditor_id}/${user_id}`);
      console.log("AppWorkflow - getDebtors from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "fetchDebtors", payload: response.data, creditor_id });
    } catch (err) {
      console.log("AppWorkflow - getDebtors from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const fetchDebtor = (dispatch) => {
  return async (debtor_id, user_id) => {
    try {
      const response = await backend.get(`/debtor/${debtor_id}/${user_id}`);
      console.log("AppWorkflow - getDebtor from dataContext - Promise Resolved data:", response.data);
      dispatch({ type: "fetchDebtor", payload: response.data });
    } catch (err) {
      console.log("AppWorkflow - getDebtor from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const changeApertura = (dispatch) => {
  return async (creditor_id, week_date, apertura_date) => {
    try {
      await backend.post("/route/toggle/apertura", { creditor_id, week_date, apertura_date });

      dispatch({
        type: "setSnackbar",
        payload: { open: true, type: "success", duration: 3000, message: "Apertura de cobro actualizada!" },
      });
    } catch (err) {
      console.log("AppWorkflow - getDebtor from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const fetchLoans = (dispatch) => {
  return async (user_id, creditor_id, next_week_date) => {
    try {
      const response = await backend.get(`/loans/${creditor_id}/${user_id}/${next_week_date}`);
      console.log("AppWorkflow - getLoans from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "fetchLoans", payload: response.data, creditor_id });
    } catch (err) {
      console.log("AppWorkflow - getLoans from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const fetchLoanDetail = (dispatch) => {
  return async (money_id) => {
    try {
      const response = await backend.post("/loan/detail", { money_id });
      console.log("AppWorkflow - getLoan from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "fetchLoan", payload: response.data });
    } catch (e) {
      console.log("AppWorkflow - getLoan from dataContext - Restored State");
    }
  };
};

const updateBankAmount = (dispatch) => {
  return async (data) => {
    try {
      await backend.put("/route/bank", { ...data });
      // dispatch({ type: "updateBankAmount", payload: { data } });

      dispatch({
        type: "setSnackbar",
        payload: { open: true, type: "info", duration: 3000, message: "Banco actualizado con exito!" },
      });
    } catch (err) {
      console.log("AppWorkflow - updateBankAmount from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const updateEfectivoAmount = (dispatch) => {
  return async (data) => {
    try {
      await backend.put("/route/efectivo", { ...data });
      // dispatch({ type: "updateEfectivoAmount", payload: data });

      dispatch({
        type: "setSnackbar",
        payload: { open: true, type: "info", duration: 3000, message: "Efectivo actualizado con exito!" },
      });
    } catch (err) {
      console.log("AppWorkflow - updateEfectivoAmount from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const fetchCobroList = (dispatch) => {
  return async (creditor_id, current_week) => {
    try {
      const response = await backend.post("/route/calculate/cobro", { creditor_id, current_week });
      console.log("AppWorkflow - fetchCobroList from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "fetchCobroList", payload: response.data });
    } catch (e) {
      console.log("AppWorkflow - fetchCobroList from dataContext - Restored State");
    }
  };
};

const fetchCobroListChanges = (dispatch) => {
  return async (creditor_id, current_week) => {
    try {
      const response = await backend.post("/route/calculate/cobro/changes", { creditor_id, current_week });
      console.log("AppWorkflow - fetchCobroListChanges from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "fetchCobroListChanges", payload: response.data });
    } catch (e) {
      console.log("AppWorkflow - fetchCobroListChanges from dataContext - Restored State");
    }
  };
};

const fetchCuadreData = (dispatch) => {
  return async (creditor_id, current_week) => {
    try {
      const response = await backend.get(`/route/cuadre/${creditor_id}/${current_week}`);
      console.log("AppWorkflow - fetchCuadre from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "fetchCuadre", payload: response.data });
    } catch (e) {
      console.log("AppWorkflow - fetchCuadre from dataContext - Restored State");
    }
  };
};

const createDebtor = (dispatch) => {
  return async (data2, callback, oldLoan) => {
    try {
      const { data } = await backend.post("/debtor/create", { data: data2 });
      console.log("AppWorkflow - createDebtor from dataContext - Promise Resolved data:", data);
      // dispatch({ type: "createDebtor", payload: data });

      dispatch({
        type: "setSnackbar",
        payload: { open: true, duration: 3000, type: "success", message: "Cliente fue registrado!" },
      });

      const header = !oldLoan ? `/loan/old/create/${data.debtor_id}` : `/loan/create/${data.debtor_id}`;
      callback(header);
    } catch (err) {
      console.log("AppWorkflow - createDebtor from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const updateDebtor = (dispatch) => {
  return async (data, callback) => {
    try {
      const response = await backend.put("/debtor", { data });
      console.log("AppWorkflow - updateDebtor from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "updateDebtor", payload: data });

      dispatch({
        type: "setSnackbar",
        payload: { open: true, duration: 3000, type: "info", message: `Cliente ${data.name} fue actualizado!` },
      });

      callback();
    } catch (err) {
      console.log("AppWorkflow - updateDebtor from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const fetchRouteData = (dispatch) => {
  return async (user_id, creditor_id) => {
    try {
      const response = await backend.post("/dashboard", { user_id, creditor_id });
      console.log("AppWorkflow - getRouteData from dataContext - Promise Resolved data:", response.data);

      // dispatch({ type: "fetchRouteData", payload: response.data, creditor_id });
    } catch (err) {
      console.log(err.message);
      console.log("AppWorkflow - getRouteData from dataContext - Catch Error");
    }
  };
};

const fetchEmployees = (dispatch) => {
  return async (user_id, creditor_id) => {
    try {
      const response = await backend.post("/employees", { user_id, creditor_id });
      console.log("AppWorkflow - fetchEmployees from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "fetchEmployees", payload: response.data, creditor_id });
    } catch (err) {
      console.log("AppWorkflow - fetchEmployees from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const fetchCollected = (dispatch) => {
  return async (creditor_id, dates) => {
    try {
      const response = await backend.post("/loans/collected", { creditor_id, ...dates });
      console.log("AppWorkflow - fetchCollected from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "fetchCollected", payload: response.data, creditor_id, dates });
    } catch (e) {
      console.log("AppWorkflow - fetchCollected from dataContext - Restored State");
    }
  };
};

const createPayment = (dispatch) => {
  return async (data) => {
    try {
      const res = await backend.post("/payment/createv2", { data });

      dispatch({
        type: "setSnackbar",
        payload: { open: true, type: "success", duration: 4000, message: "Pago registado con exito!" },
      });

      return "success";
    } catch (err) {
      console.log("AppWorkflow - createPayment from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const deletePayment = (dispatch) => {
  return async ({ payment_id, invoice_id, customer_id }) => {
    try {
      await backend.delete(`/payment/delete/${payment_id}/${invoice_id}/${customer_id}`);

      dispatch({
        type: "setSnackbar",
        payload: { open: true, type: "warning", duration: 4000, message: "Pago borrado con exito!" },
      });
    } catch (err) {
      console.log("AppWorkflow - createPayment from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const createGasto = (dispatch) => {
  return async (data) => {
    try {
      await backend.post("/gasto/create", { data });
      // dispatch({ type: "createGasto", payload: response.data });

      dispatch({
        type: "setSnackbar",
        payload: { open: true, type: "success", duration: 3000, message: "Gasto registado con exito!" },
      });
    } catch (err) {
      console.log("AppWorkflow - createGasto from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const deleteGasto = (dispatch) => {
  return async (data) => {
    try {
      await backend.delete(`/gasto/${data.id}/${data.creditor_id}/${data.user_id}`);
      // dispatch({ type: "deleteGasto", payload: response.data });

      dispatch({
        type: "setSnackbar",
        payload: { open: true, type: "warning", duration: 3000, message: "Gasto borrado con exito!" },
      });
    } catch (err) {
      console.log("AppWorkflow - deleteGasto from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const debtorDelete = (dispatch) => {
  return async (debtor_id, user_id, history) => {
    try {
      await backend.delete(`/debtor/${debtor_id}/${user_id}`);
      // dispatch({ type: "debtorDelete", payload: response.data });

      history.replace("/dashboard");

      dispatch({
        type: "setSnackbar",
        payload: { open: true, type: "warning", duration: 3000, message: "Cliente borrado con exito!" },
      });
    } catch (err) {
      console.log("AppWorkflow - deleteGasto from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const loanDelete = (dispatch) => {
  return async (money_id, user_id, history) => {
    try {
      await backend.delete(`/loan/${money_id}/${user_id}`);
      // dispatch({ type: "loanDelete", payload: response.data });

      history.replace("/dashboard");

      dispatch({
        type: "setSnackbar",
        payload: { open: true, type: "warning", duration: 3000, message: "Prestamos borrado con exito!" },
      });
    } catch (err) {
      console.log("AppWorkflow - deleteGasto from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const fetchGastos = (dispatch) => {
  return async (creditor_id, dates) => {
    try {
      const response = await backend.post("/spenses", { creditor_id, ...dates });
      console.log("AppWorkflow - fetchGastos from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "fetchGastos", payload: response.data, creditor_id, dates });
    } catch (err) {
      console.log("AppWorkflow - fetchGastos from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const toggleDarkMode = (dispatch) => {
  return () => {
    dispatch({ type: "toggleDarkMode" });
  };
};

const getDebtorLoans = (dispatch) => {
  return async (data) => {
    try {
      const response = await backend.post("/debtor/loans", { data });
      console.log("AppWorkflow - getDebtorLoans from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "getDebtorLoans", payload: { loans: response.data, ...data } });
    } catch (err) {
      console.log("AppWorkflow - getDebtorLoans from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const getUserRoutesBalance = (dispatch) => {
  return async (owner_id, callback = null) => {
    try {
      const response = await backend.post("/user/routes/balance", { owner_id });
      console.log("AppWorkflow - getUserRoutesBalance from dataContext - Promise Resolved data:", response.data);
      // dispatch({ type: "getUserRoutesBalance", payload: response.data });
      if (response.data.balance > 0 && callback) callback();
    } catch (err) {
      console.log("AppWorkflow - getUserRoutesBalance from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const getContractoLetter = () => {
  return async (creditor_id) => {
    try {
      const response = await backend.post("/route/contract/letter", { creditor_id });
      console.log("AppWorkflow - getContractoLetter from dataContext - Promise Resolved data:", response.data);
      return response.data;
    } catch (err) {
      console.log("AppWorkflow - getContractoLetter from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

const getAtrasosLetter = () => {
  return async (creditor_id) => {
    try {
      const response = await backend.post("/route/contract/letter", { creditor_id });
      console.log("AppWorkflow - getAtrasosLetter from dataContext - Promise Resolved data:", response.data);
      return response.data;
    } catch (err) {
      console.log("AppWorkflow - getAtrasosLetter from dataContext - Catch error");
      console.log(err.message);
    }
  };
};

export {
  signinUser,
  createGasto,
  createPayment,
  getUserRoutesBalance,
  fetchGastos,
  getContractoLetter,
  setUserRole,
  createRoute,
  fetchCollected,
  toggleLinkedRoute,
  createEmployee,
  fetchEmployees,
  setReferral,
  createLoan,
  toggleDarkMode,
  getDebtorRenewal,
  getAtrasosLetter,
  getDebtorLoans,
  fetchLoans,
  fetchDebtor,
  fetchDebtors,
  createDebtor,
  updateDebtor,
  updateUserConfig,
  updateRouteConfig,
  fetchRouteData,
  changeRoute,
  fetchNewLoans,
  fetchCuadreData,
  fetchCobroList,
  deleteGasto,
  loanDelete,
  modifyLoan,
  debtorDelete,
  fetchCobroListChanges,
  fetchLoanDetail,
  fetchLoanPayments,
  modifyRoute,
  modifyRouteConfig,
  generateAccessCodes,
  createLoanWithAtrasos,
  fetchDebtorImages,
  deletePayment,
  changeApertura,
  updateBankAmount,
  updateEfectivoAmount,
  setDebtorsReorderedMain,
  dispatchAction,
};
